const AES256 = require('aes-everywhere')

export function generateShortToken(tempId, shortKey) {
  const encryptionKey = process.env.VUE_APP_SHORT_KEY_SECRET || 'secret'
  const payloadString = `$${tempId}$`
  const encrypted = AES256.encrypt(payloadString, `${encryptionKey}${shortKey}`)
  const token = `${encrypted}$${shortKey}`
  return token
}
